import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Layout,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router-dom';

import './index.less';

import { withRouter } from '../../hooks/withRouter';
import { NOMINATION_WRITE_PERMISSIONS, NOMINATIONS_READ_PERMISSIONS } from '../../constants/users';
import { userHasPermission } from '../../utils/userHelpers';
import Context from '../../context';
import NewNomination from '../../components/Nomination/newNomination';
import NominationsSummary from '../../components/NominationsSummary';
import PageHeaderBar from '../../components/PageHeaderBar';
import NominationInfo from './nominationInfo';
import { UNITS_EXTENDED } from '../../constants/units';
import MatchNomination from './matchNomination';

const Nominations = (props) => {
  const { navigate } = props;
  const { t } = useTranslation();

  const context = useContext(Context);
  const {
    isReadOnlyAdmin,
    isReadOnlyAdminAsMarketParty,
    isAdmin,
    isAdminAsMarketParty,
    selectedMarketPartyId,
  //  activeBalanceGroupId,
  } = context;

  const [nominationData, setNominationData] = useState();
  const [nominationKey, setNominationKey] = useState('');
  const [selectedUnit, setSelectedUnit] = useState(UNITS_EXTENDED.KWH);

  // TODO: This solution does not account for balance group for the future dates allowed
  // const hasBalanceGroup = activeBalanceGroupId && activeBalanceGroupId !== '';
  const hasBalanceGroup = true;
  const canCreateNomination = selectedMarketPartyId !== 'admin' && (userHasPermission(context, NOMINATION_WRITE_PERMISSIONS)
    || isAdmin(true) || isAdminAsMarketParty());
  const canViewNomination = canCreateNomination || userHasPermission(context, NOMINATIONS_READ_PERMISSIONS)
    || isReadOnlyAdmin() || isReadOnlyAdminAsMarketParty();

  const handleNewNominationClick = () => {
    navigate('/nominations/new-nomination');
  };

  const renderButton = () => (
    <Button
      className="page__header__buttons__new-nomination"
      data-testid="page__header__buttons__new-nomination"
      type="primary"
      disabled={!hasBalanceGroup}
      onClick={handleNewNominationClick}
    >
      {t('nominations.button.newNomination')}
    </Button>
  );

  return (
    <>
      <PageHeaderBar
        title={t('nominations.title.yourNominations')}
        data-testid="page__header-bar"
        actionItems={canCreateNomination ? renderButton() : null}
      />
      <Layout.Content className="layout__container__page__content nominations">
        <NominationsSummary
          canCreateNomination={canCreateNomination}
          canViewNomination={canViewNomination}
          selectedUnit={selectedUnit}
          setSelectedUnit={setSelectedUnit}
          setNominationData={setNominationData}
          setNominationKey={setNominationKey}
        />
      </Layout.Content>
      <Routes>
        {canCreateNomination && (
          <Route
            path="new-nomination"
            element={<NewNomination />}
          />
        )}
        {canViewNomination && (
          <Route
            path="renomination"
            element={(
              <NewNomination
                nominationData={nominationData}
                canViewOnly={!canCreateNomination}
              />
            )}
          />
        )}
        <Route
          path="info"
          element={(
            <NominationInfo
              nominationKey={nominationKey}
              unit={selectedUnit}
            />
          )}
        />
        {nominationData !== undefined && (
          <Route
            path="match"
            element={<MatchNomination nomination={nominationData} />}
          />
        )}
      </Routes>
    </>
  );
};

Nominations.displayName = 'Nominations';
Nominations.propTypes = {
  navigate: PropTypes.func.isRequired,
};

export default withRouter(Nominations);
export {
  Nominations as PureComponent,
};
